module.exports = __webpack_public_path__ + "media/assets/icons/checkboxes/check-circle-unchecked-ffc2ad49874521ccf822dbd655d7a3cc.svg";